import type { SvgPathProps } from '../Icon';

const DataReceived: React.FC<SvgPathProps> = ({ isHovered }: SvgPathProps): React.ReactElement => {
  const normal = (
    <path
      fillRule={'evenodd'}
      d="M23.901 27.741H5.416v-1.3h18.45l-3.779-3.778.92-.92 4.906 4.905a.653.653 0 010 .92l-4.97 4.971-.92-.92 3.878-3.878zm4.777-13.23c-7.82 0-12.813-1.891-12.813-3.194s4.992-3.194 12.813-3.194c7.822 0 12.814 1.892 12.814 3.194 0 1.303-4.992 3.194-12.814 3.194zm0-7.688c-7.013 0-14.113 1.543-14.113 4.493v13.106h1.3V13.315c2.363 1.646 7.608 2.497 12.813 2.497 5.205 0 10.451-.851 12.814-2.497V38.09c0 1.301-4.992 3.193-12.814 3.193-7.82 0-12.813-1.892-12.813-3.193v-8.23h-1.3v8.23c0 2.95 7.1 4.494 14.113 4.494 7.014 0 14.114-1.544 14.114-4.494V11.316c0-2.95-7.1-4.494-14.114-4.494z"
    />
  );

  const normalHover = (
    <path
      fillRule={'evenodd'}
      d="M26.607 27.741H5.416v-1.3h21.156l-3.78-3.778.92-.92 4.907 4.905a.65.65 0 010 .92l-4.97 4.971-.92-.92 3.878-3.878zm2.072-13.23c-7.822 0-12.814-1.891-12.814-3.194s4.992-3.194 12.814-3.194 12.813 1.892 12.813 3.194c0 1.303-4.991 3.194-12.813 3.194zm0-7.688c-7.014 0-14.114 1.543-14.114 4.493v13.106h1.3V13.315c2.363 1.645 7.609 2.497 12.814 2.497 5.204 0 10.45-.852 12.813-2.497V38.09c0 1.301-4.991 3.193-12.813 3.193-7.822 0-12.814-1.892-12.814-3.193v-8.23h-1.3v8.23c0 2.95 7.1 4.494 14.114 4.494 7.013 0 14.113-1.544 14.113-4.494V11.316c0-2.95-7.1-4.494-14.113-4.494z"
    />
  );

  return isHovered ? normalHover : normal;
};

export default DataReceived;
